// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"717":"e9948d37","856":"e9948d37"}[chunkId] + ".chunk.css";
};